import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TabsComponent from '../../components/common/Tabs.component';
import TemplateList from '../templates/List.template';
import locations from '../../module/locations';
import {
  PATH_TAB_INDEX,
  TAB_CATEGORIES,
  TAB_LOCATIONS,
  TAB_SUB_CATEGORIES,
  TAB_TEAMS,
} from '../../module/settings/Data.conf';
import categories from '../../module/categories';
import _ from 'lodash';
import subCategories from '../../module/subCategories';
import teams from '../../module/teams';

const DEFAULT_TAB = TAB_LOCATIONS;
const SettingsPage = ({ currentTabId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [valueTab, setValueTab] = useState(null);

  const optionsTabs = useMemo(
    () => [
      {
        id: TAB_LOCATIONS,
        label: 'LOCATIONS',
        children: valueTab === TAB_LOCATIONS && (
          <TemplateList module={locations} />
        ),
      },
      {
        id: TAB_CATEGORIES,
        label: 'CATEGORIES',
        children: valueTab === TAB_CATEGORIES && (
          <TemplateList module={categories} />
        ),
      },
      {
        id: TAB_SUB_CATEGORIES,
        label: 'SUB CATEGORIES',
        children: valueTab === TAB_SUB_CATEGORIES && (
          <TemplateList module={subCategories} />
        ),
      },
      {
        id: TAB_TEAMS,
        label: 'TEAMS',
        children: valueTab === TAB_TEAMS && (
          <TemplateList module={teams} />
        ),
      },
    ],
    [valueTab]
  );

  const handleTabChange = (tabIndex) => {
    navigate(`/settings${PATH_TAB_INDEX?.[tabIndex]}`);
  };

  const handleChange = (newValue) => {
    setValueTab(newValue);
    handleTabChange(newValue);
  };

  useEffect(() => {
    const currentPath = location.pathname;

    const matchedKey = _.findKey(PATH_TAB_INDEX, (value) =>
      _.includes(currentPath, value)
    );
    if (matchedKey) {
      setValueTab(matchedKey);
    }
  }, [location.pathname]);

  useEffect(() => {
    setValueTab(currentTabId || DEFAULT_TAB);
    navigate(
      `/settings${currentTabId ? PATH_TAB_INDEX?.[currentTabId] : PATH_TAB_INDEX?.[DEFAULT_TAB]}`
    );
  }, [navigate, currentTabId]);

  return (
    <TabsComponent
      defaultTab={valueTab}
      onChangeTab={handleChange}
      tabs={optionsTabs}
    />
  );
};

export default SettingsPage;
